import { useState } from "react";
import { tss } from "tss-react/mui";
import { Info, Straighten, WbSunny } from "@mui/icons-material";
import { Scrollbars } from "react-custom-scrollbars";
import { SliceToolIcon } from "assets/images";
import { panelHeight, panelRight } from "constants/ui";
import { PanelHeader, Section } from "components";
import { InfoPanel, MeasurePanel, LightingPanel, SlicePanel } from "./";
import commonStyles, { panelWidth, buttonsColor } from "styles/common";

var useStyles = tss.create(({theme}) => ({
    root: {
        position: "absolute",
        display: "table",
        borderRadius: 5,
        width: panelWidth,
        height: 80,
        top: panelHeight,
        maxHeight: "calc(100vh - 227px)",
        useSelect: "none",
    },
    sectionIcon: {
        marginLeft: -5,
        marginRight: 10,
        color: theme.palette.text.secondary,
    },
    sectionContent: {
        width: panelWidth,
    },
}));

const initialState = {
    info: false,
    measure: false,
    lighting: false,
    slice: false,
};

type IProps = {
    slideLeft: boolean;
    handleClose: () => void;
};

export default function RightPanel(props: IProps) {
    const { classes: common } = commonStyles();
    const { classes, cx } = useStyles();
    const { handleClose, slideLeft } = props;
    const [collapse, setCollapse] = useState({ ...initialState });
    const handleCollapse = (name: string, status: boolean) => {
        var newState: any = { ...collapse };
        newState[name] = status;
        setCollapse(newState);
    };
    return (
        <div className={cx(common.middle, classes.root)} style={{ right: props.slideLeft ? 301 : panelRight.tools }}>
            <Scrollbars
                autoHeight
                autoHeightMax={"calc(100vh - 110px)"}
                style={{ overflowX: "hidden", width: panelWidth }}
            >
                <PanelHeader title={"Viewer Tools"} handleClose={handleClose} />
                <Section
                    name="slice"
                    icon={<SliceToolIcon className={classes.sectionIcon} />}
                    label="Cross-Section"
                    onCollapse={handleCollapse}
                >
                    <div className={common.sectionContent}>
                        {collapse["slice"] ? <SlicePanel show={collapse["slice"]} /> : ""}
                    </div>
                </Section>
                <Section
                    name="info"
                    icon={<Info className={classes.sectionIcon} />}
                    label="Feature Info"
                    onCollapse={handleCollapse}
                >
                    <div className={common.sectionContent}>
                        {collapse["info"] ? <InfoPanel show={collapse["info"]} commentShowing={slideLeft} /> : ""}
                    </div>
                </Section>
                <Section
                    name="measure"
                    icon={<Straighten className={classes.sectionIcon} />}
                    label="Measure"
                    onCollapse={handleCollapse}
                >
                    <div className={common.sectionContent}>
                        {collapse["measure"] ? <MeasurePanel show={collapse["measure"]} /> : ""}
                    </div>
                </Section>
                <Section
                    name="lighting"
                    icon={<WbSunny className={classes.sectionIcon} />}
                    label="Lighting"
                    onCollapse={handleCollapse}
                >
                    <div className={common.sectionContent}>
                        {collapse["lighting"] ? <LightingPanel show={collapse["lighting"]} /> : ""}
                    </div>
                </Section>
            </Scrollbars>
        </div>
    );
}
